import React from "react";

const HomePage = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "600px", margin: "auto" }}>
      hello
    </div>
  );
};

export default HomePage;